// extracted by mini-css-extract-plugin
export default {"fetching":"NonEmpty-module__fetching___afU8X"};